import React, { useLayoutEffect, useRef, useState } from "react";
import { Button } from "../Button";

type Props = {
    summary?: React.ReactNode;
    details?: React.ReactNode;
    summaryText?: string;
    detailsText?: string;

    moreLink?: string;
    moreButton?: string;
    lessButton?: string;

    buttonFullWidth?: boolean;

    className?: string;
    moreLinkClassName?: string;
    moreButtonClassName?: string;
    summaryClassName?: string;
    detailsClassName?: string;
};

const Accordion: React.FC<Props> = ({
                                        summary,
                                        details,
                                        summaryText,
                                        detailsText,
                                        moreLink,
                                        moreButton,
                                        buttonFullWidth,
                                        lessButton,
                                        className = "",
                                        moreLinkClassName = "",
                                        moreButtonClassName = "",
                                        summaryClassName = "",
                                        detailsClassName = "",
                                    }) => {
    const [isOpen, setIsOpen] = useState(false);
    const contentRef = useRef<HTMLDivElement | null>(null);
    const [maxH, setMaxH] = useState(0);

    useLayoutEffect(() => {
        const el = contentRef.current;
        if (!el) return;

        const updateHeight = () => {
            if (!contentRef.current) return;
            setMaxH(contentRef.current.scrollHeight);
        };

        if (isOpen) {
            updateHeight();
        } else {
            setMaxH(0);
        }

        if (typeof ResizeObserver === "undefined") return;

        const observer = new ResizeObserver(() => {
            if (isOpen) {
                updateHeight();
            }
        });

        observer.observe(el);

        return () => {
            observer.disconnect();
        };
    }, [isOpen]);

    return (
        <div className={`w-full ${className}`}>
            <div className={summaryClassName}>
                {summary || (summaryText ? <p>{summaryText}</p> : null)}
            </div>

            <div
                className={`mt-2 overflow-hidden transition-[max-height,opacity] duration-300 ease-in-out ${
                    isOpen ? "opacity-100" : "opacity-0"
                } ${detailsClassName}`}
                style={{ maxHeight: isOpen ? maxH : 0 }}
            >
                <div ref={contentRef} className="pb-2">
                    {details || (detailsText ? <p>{detailsText}</p> : null)}
                </div>
            </div>

            <div className="mt-2 flex gap-2">
                {moreLink && (
                    <a
                        href={moreLink}
                        className={`text-[#007bff] no-underline hover:underline ${moreLinkClassName}`}
                    >
                        {moreLink}
                    </a>
                )}

                {moreButton && (
                    <Button
                        onClick={() => setIsOpen((v) => !v)}
                        className={moreButtonClassName}
                        text={isOpen ? lessButton || "Скрыть" : moreButton}
                        fullWidth={buttonFullWidth}
                    />
                )}
            </div>
        </div>
    );
};

export default Accordion;
